module.exports = __webpack_public_path__ + "img/furo.a9ffb596.png";